import { kanboardConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";

//get job details
export const get_kanboard_job_details_hiring_manager_action =
  (id) => async (dispatch) => {
    dispatch({
      type: kanboardConstants.GET_KANBOARD_JOBS_HIRING_MANAGER_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.hiringManager.kanboardJobDetail.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: kanboardConstants.GET_KANBOARD_JOBS_HIRING_MANAGER_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: kanboardConstants.GET_KANBOARD_JOBS_HIRING_MANAGER_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

//get filtered job details
export const get_kanboard_filtered_job_details_hiring_manager_action =
  (id, interview_stage) => async (dispatch) => {
    dispatch({
      type: kanboardConstants.GET_KANBOARD_FILTERED_JOBS_HIRING_MANAGER_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.hiringManager.kanboardJobDetail.replace(
          ":id",
          id
        )}${interview_stage}/`
      );
      if (response.status) {
        dispatch({
          type: kanboardConstants.GET_KANBOARD_FILTERED_JOBS_HIRING_MANAGER_ACTION_SUCCESS,
          payload: response.data,
          status: interview_stage,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: kanboardConstants.GET_KANBOARD_FILTERED_JOBS_HIRING_MANAGER_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

export const update_applicant_profile_status_kanboard_hiring_manager_action =

  (id, data) => async (dispatch) => {
    dispatch({
      type: kanboardConstants.UPDATE_APPLICANT_PROFILE_STATUS_KANBOARD_HIRING_MANAGER_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.hiringManager.kanboardApplicantStatusUpdate.replace(
          ":id",
          id
        ),
        data
      );
      if (response.status) {
        dispatch({
          type: kanboardConstants.UPDATE_APPLICANT_PROFILE_STATUS_KANBOARD_HIRING_MANAGER_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: kanboardConstants.UPDATE_APPLICANT_PROFILE_STATUS_KANBOARD_HIRING_MANAGER_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };
